<div class="card">
    <div class="card-body">
        <div class="row" style="border: 2px solid #188cf9;border-radius: 2px;">
            <div class="col-md-3" style="padding: 3px;height: 40px;background: #188cf9;">
            <label>
            <h4 style="padding: 5px;color: #f4f6f9;border-radius: 5px">Rules</h4>
            </label>
            </div>
            <div class="col-md-3" style="padding: 3px;height: 40px;background: #188cf9;">
            <label>
            <h4 style="padding: 5px;color: #f4f6f9;border-radius: 5px">Applied Rules</h4>
            </label>
            </div>
            <div class="col-md-6" style="padding: 3px;height: 40px;background: #188cf9;">
            <label>
            <h4 style="padding: 5px;color: #f4f6f9;border-radius: 5px">Properties</h4>
            </label>
            </div>
            <div class="col-md-6" style="padding: 20px;">
                <div class="flex">
                    <div class="container" style="border-right: 1px solid #9eb2cc" dragula="VAMPIRES" id="left" [(dragulaModel)]="ruleLeft" >
                    <div class="vamp" *ngFor="let vampL of ruleLeft" (click)="selectedLeft(vampL)">{{vampL.Name}}</div>
                    </div>
                    <div class="container" dragula="VAMPIRES" id="right" [(dragulaModel)]="ruleRight" >
                        <div class="vamp" *ngFor="let vampR of ruleRight"  (click)="selectedRight(vampR)"  >
                            <div (dblclick)="dbClick(vampR)">
                                <i class="mdi mdi-pencil" (click)="isEditable(vampR)" ></i><span style="padding-right: 1px;">{{vampR.TempNameLabel}}</span>
                                <!-- <input (keydown.enter)="onEnter(vampR)" [ngClass]="vampR.Style" [disabled]="vampR.IsDisabled"  type="text" id="vR" name="name" [(ngModel)]="vampR.Name" style="border: none;background: none;"> -->
                                <!-- <span #isCheck (click)="checkClick()"></span> -->
                                <input (keydown.enter)="onEnter(vampR)" [ngClass]="vampR.Style" [disabled]="vampR.IsDisabled"  type="text" id="vR" name="name" [(ngModel)]="vampR.TempNameTextField" style="width: 100px;">
                            </div>
                           
                        </div> 
                    </div>
                </div>
            </div>
     
            <div class="col-md-6" style="padding-top: 20px;border: 2px solid #188cf9;border-bottom: none;border-top: none;border-right: none;">
                <!-- <div #container></div> -->
               <span *ngIf="selectedRightRule.RuleProperty.length > 0">
                  <div>
                    <span *ngFor="let sep of seperator" >
                        <div>
                            <!-- <button class="btn-info.btn-outline:hover btn-save-rule" style="margin-top:10px;"  (click)="close(sep)" id="{{sep}}">close</button> -->
                            <button class="k-button k-primary btn-info.btn-outline:hover" kendoButton  style="margin-top:10px; float: right;"  (click)="close(sep)" id="{{sep}}">close</button>
                        </div>
                        <span  *ngFor="let field of selectedRightRule.RuleProperty" > 
                            <span *ngIf="field.divId == sep">
                             <span [ngSwitch]="field.Type">
                                    <span *ngSwitchCase="'textfield'" style="padding-left: 5px;">
                                        <label for="inputname" class="control-label col-form-label " style="font-size: 11px;" >{{field.Name}} 
                                        <input type="text"   name="field.Name"  [(ngModel)]="field.Value" class="form-control " style="width: 160px;height: 31px;font-size: 11px;border-radius: 4px;
                                        border-color: #d0cdd0;" >
                                        </label>
                                    </span>
                                    <span *ngSwitchCase="'combobox'" style="padding: 2px;">
                                        <label for="inputname" class="control-label col-form-label " style="font-size: 11px;">{{field.Name}}  
                                        <select  [(ngModel)]="field.Value" name="field.Name" (ngModelChange)="onChange($event,field.divId)" class="form-control" style="width: 160px;height: 31px;font-size: 11px;" > 
                                            <option  *ngFor="let item of  field.Store" [ngValue]="item.value">{{item.name}}</option> 
                                        </select> 
                                    </label>
                                    </span>

                                    <span *ngSwitchCase="'ngSelect'" style="padding: 2px;">
                                        <label for="inputname" class="xxx" style="font-size: 11px;">{{field.Name}}  
                                            <ng-select  [searchWhileComposing] = "true" (search)="execKeypress($event,rule.field)" [searchable]="true" class="form-control"  [clearSearchOnAdd] = "true"  [loading]="loading"   [virtualScroll]="true"  
                                              bindLabel = "field.Name" (ngModelChange)="onChange($event,field.divId)" (scrollToEnd)="fetchMore(field)" style="width: 160px; height: 29px;" [(ngModel)]="field.Value">
                                              <ng-option *ngFor="let item of  field.Store" [value]="item.value" style="border: none;">{{item.name}}</ng-option>
                                            </ng-select>
                                        </label>
                                    </span>



                                    <span *ngSwitchCase="'multiselect'" style="padding: 2px;">
                                        <label for="inputname"class="control-label col-form-label " style="font-size: 11px;">{{field.Name}}  
                                            <ng-select  [searchWhileComposing] = "true" (search)="execKeypress($event,rule.field)" [searchable]="true"  [multiple] = "true"  class="form-control"  [clearSearchOnAdd] = "true"  [loading]="loading"   [virtualScroll]="true"  
                                              bindLabel = "field.Name" (ngModelChange)="onChange($event,field.divId)" (scrollToEnd)="fetchMore(field)" class="form-control" style="width: 160px;height: 29px;font-size: 11px; margin-left: 5px;
                                              border:none;
                                              padding: 0px;
                                              display: inline-grid;"   [(ngModel)]="field.Value">
                                              <ng-option *ngFor="let item of  field.Store" [value]="item.value">{{item.name}}</ng-option>
                                            </ng-select>
                                        </label>
                                    </span>

                                    <span *ngSwitchCase="'multiselect2'" style="padding: 2px;">
                                        <label for="inputname"class="control-label col-form-label " style="font-size: 11px;">{{field.Name}}  
                                            <ng-select  [searchWhileComposing] = "true" (search)="execKeypress($event,rule.field)" [searchable]="true"  [multiple] = "false"  class="form-control"  [clearSearchOnAdd] = "true"  [loading]="loading"   [virtualScroll]="true"  
                                              bindLabel = "field.Name" (ngModelChange)="onChange($event,field.divId)" (scrollToEnd)="fetchMore(field)" class="form-control" style="width: 160px;height: 29px;font-size: 11px; margin-left: 5px;
                                              border:none;
                                              padding: 0px;
                                              display: inline-grid;"  [(ngModel)]="field.Value">
                                              <ng-option *ngFor="let item of  field.Store" [value]="item.value">{{item.name}}</ng-option>
                                            </ng-select>
                                        </label>
                                    </span>

                                    <span  *ngSwitchCase="'checkbox'" style="padding: 2px;">
                                        <input  [(ngModel)]="field.Value" type="checkbox"  name="item.Name" >  
                                       <label for="inputname" class="control-label col-form-label " style="font-size: 11px;padding-left: 3px;padding-right: 3px;">{{field.Name}} </label>
                                    
                                    </span>
                                    <span *ngSwitchCase="'int'" style="padding: 2px;">
                                                <label for="inputname" class="control-label col-form-label " style="font-size: 11px;">{{field.Name}}    </label>
                                                <input  [(ngModel)]="field.Value" type="number"   name="item.Name" class="form-control "  style="width: 160px;height: 29px;font-size: 11px;">
                                               
                                    </span>
                                    <span  *ngSwitchCase="'decimal'" style="padding: 2px;">
                                                    <label for="inputname" class="control-label col-form-label " style="font-size: 11px;">{{field.Name}}  
                                                    <input  [(ngModel)]="field.Value" type="number"   name="item.Name" class="form-control "  style="width: 160px;height: 29px;font-size: 11px;">
                                                    </label>
                                    </span>
                                    <div  *ngSwitchCase="'grid'">
                                        <div class="card" style="margin-top: 10px;"> 
                                            <kendo-grid [data]="field.Store" [pageSize]="5"  [skip]="10"  [sortable]="true"  [pageable]="true"  >
                                                <kendo-grid-column field="Name" title="Name">
                                                </kendo-grid-column>
                                                <kendo-grid-column field="Value" title="Value">
                                                </kendo-grid-column>
                                                <kendo-grid-column field="UnitsInStock" title="dropdown" >
                                                    <ng-template kendoGridCellTemplate let-dataItem>
                                                        <select >
                                                        <option *ngFor="let x of listItems" [value]="x" >{{x}}</option>
                                                    </select>
                                                    </ng-template>
                                                </kendo-grid-column>
                                            </kendo-grid>
                                        </div>
                                    </div>
                                </span>
                            </span>
                        </span>
                    </span>
                  </div>
                </span>
            </div>
            <div class="col-md-3" style="padding: 3px; height: 40px;">
                <label>
                </label>
            </div>
            <div class="col-md-3" style="padding: 3px;height: 40px;">
                <div >
                    <button  style="float: right;" class="btn-info.btn-outline:hover k-button k-primary" (click)="appliedSave()"><i class="fa fa-save"></i> Save</button>
                </div>
            </div>
            <div class="col-md-6" style="height: 40px; border: 2px solid #188cf9;border-top: none;border-radius: 0px 0px 5px 0px;border-right: none;border-bottom: none;">
           
                <div >
                    <button  style="float: right;" class="btn-info.btn-outline:hover k-button k-primary" (click)="saveProperties()"> <i class="fa fa-save"></i> Save</button>
                </div>
                <div >
                    <button    class="btn-info.btn-outline:hover k-button k-primary" style="margin-left: 2px;margin-right: 5px;float: right;" (click)="addProperties()"> Add new</button>
                </div>
            </div>
        </div>
    </div>
</div>
